/*
 * @Author: zhujiapeng
 * @Date: 2021-01-28 10:43:31
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-01-28 11:35:52
 * @Description: 埋点
 * @Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */

import CONFIG from './config';

const WEBTRACING = (eventKey, eventName, content) => {
  if (!window.logger) { 
    return
  }
  const Api = CONFIG.api.split('-')[0];
  const userAdminInfo = window.userAdminInfo || {};
  const currentUserInstInfo = window.currentUserInstInfo || {};
  const {
    instType,
    instServiceTime,
    instScale,
    instId,
    adminId
  } = userAdminInfo;
  window.logger.push("platform", "pc");
  window.logger.push("event", eventKey);
  window.logger.push("eventName", eventName);
  window.logger.push("device", navigator.userAgent);
  window.logger.push("instId", instId);
  window.logger.push("adminId", adminId);
  window.logger.push('env', Api || 'local');  // 哪个环境的埋点
  const _content = Object.assign({}, content, {
    机构名称: currentUserInstInfo.instName || currentUserInstInfo.name,
    机构类型: instType,
    购买时长: instServiceTime,
    机构规模: instScale,
    instId,
    adminId,
  });
  window.logger.push("content", JSON.stringify(_content));
  // 记录日志
  window.logger.logger();
}

export default WEBTRACING;
